import { Decimal, Numeric } from 'decimal.js-light';
export function sum(numbers: Numeric[], fixed?: number): string {
  const sumDec = numbers.reduce((pre: Decimal, item) => pre.plus(item), new Decimal(0));

  return fixed ? new Decimal(sumDec).toFixed(fixed) : sumDec.toString();
}

export function equal(src1: Numeric, src2: Numeric): boolean {
  return new Decimal(src1).eq(src2);
}

export function isASmallThanB(srcA: Numeric, srcB: Numeric): boolean {
  return new Decimal(srcA).lessThan(srcB);
}

export function isALessThanOrEqualToB(srcA: Numeric, srcB: Numeric): boolean {
  return new Decimal(srcA).lessThanOrEqualTo(srcB);
}

export function mul(x: number | string, y: number | string): Decimal {
  return new Decimal(x).mul(y);
}

export function numberWithCommas(x: string | number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function toNumber(src: Numeric): number {
  return new Decimal(src).toNumber();
}
export function div(x: number | string | Decimal, y: number | string | Decimal): Decimal {
  return new Decimal(x).div(y);
}

export function mod(x: Numeric, y: Numeric): Decimal {
  return new Decimal(x).mod(y);
}

export function minus(x: Numeric, y: Numeric): Decimal {
  return new Decimal(x).minus(y);
}

export function roundFix(x: Numeric, fixed: number): string {
  return new Decimal(x).toFixed(fixed);
}

export function fixZero(x: Numeric): Numeric {
  const isInt = new Decimal(x).isInteger();
  if (isInt) {
    return new Decimal(x).toFixed(0);
  }
  return x;
}

export function formatFloat(x: Numeric, digits: number): Numeric {
  const base = Math.pow(10, digits);
  const s = new Decimal(x).mul(base).toFixed(0);
  return new Decimal(s).div(base);
}

export function isNumberTest(x: any): boolean {
  if (typeof x !== 'string') {
    return false;
  }
  if (x.length === 0) {
    return false;
  }
  const num = Number(x);
  return !isNaN(num);
}
